const setImportSheetModalStateAction = ({ commit }, payload) => {
  commit('setImportSheetModalState', payload)
}

const setAIRequestLimitModalStateAction = ({ commit }, payload) => {
  commit('setAIRequestLimitModalState', payload)
}

const setShowModalTemplateLibraryAction = ({ commit }, payload) => {
  commit('setShowModalTemplateLibraryState', payload)
}

export default {
  setImportSheetModalStateAction,
  setAIRequestLimitModalStateAction,
  setShowModalTemplateLibraryAction,
}
